package com.macrofocus.eflux.ui

import com.macrofocus.common.properties.MutableProperty
import i18next.invoke
import i18next.useTranslation
import korlibs.time.DateTime
import mui.material.Snackbar
import mui.material.SnackbarCloseReason
import mui.material.SnackbarOrigin
import org.mkui.react.useProperty
import react.*
import react.dom.events.SyntheticEvent

external interface UpdateIndicatorProps : PropsWithChildren {
    var latestDateTimeProperty: MutableProperty<DateTime>
    var maxDateTimeProperty: MutableProperty<DateTime>
    var liveProperty: MutableProperty<Boolean>
    var anchorOrigin: SnackbarOrigin?
}

val UpdateIndicator = FC<UpdateIndicatorProps> { props ->
    val (t, _) = useTranslation()

    val (getLatest, _) = useProperty(props.latestDateTimeProperty)
    val (getMax, _) = useProperty(props.maxDateTimeProperty)
    val (getLive, _) = useProperty(props.liveProperty)

    val (getOpen, setOpen) = useState(false)

    useEffect(getLatest.unixMillis) {
        setOpen(true)
    }

    Snackbar {
        key = "update"
        onClose = { event: SyntheticEvent<*, *>?, _: SnackbarCloseReason ->
            setOpen(false)
        }
        open = getOpen
        autoHideDuration = 30000

        if(props.anchorOrigin != null) {
            anchorOrigin = props.anchorOrigin
        }

        val date = getLatest.format("dd.MM.yyyy HH:mm")
        message = if(getLive) {
            val update = t("appMenu.configuration.update.update")
            ReactNode("$update $date")
        } else {
            val new = t("appMenu.configuration.update.new")
            ReactNode("$new $date")
        }
    }
}